module.exports =
 {
    version:"5.3.2.202310091930",
    buildDate:"202310091930", 
    buildMode:"release" 
 };
